import React, {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getSponsorships} from '../core/_requests'
import {Sponsorship} from '../core/_models'
import {Columns} from './columns/_columns'
import {FilterForm, initialFilters} from './components/FilterForm'
import SponsorshipForm from './components/SponsorshipForm'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  if (itemForUpdate !== undefined && action === 'details') {
    const s = itemForUpdate as Sponsorship

    return (
      <Modal
        title={
          <>
            Sponsorship details
            <span className="text-danger ps-2">{s.user.email}</span>
          </>
        }
        maxWidth={800}>
        <SponsorshipForm />
      </Modal>
    )
  }

  return (<></>)
}

const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Sponsorship</PageTitle>
    <TableWrapper
      dataProvider={getSponsorships}
      cols={Columns}
      queryId="P2C_SPONSOR_LIST"
      modals={ModalWrapper}
      lookup={{
        placeholder: 'Search sponsorship',
        fields: ['email', 'username', 'key']
      }}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
    />
  </>
)

export default ListWrapper
